import React, { useState, useMemo } from 'react';
import TextInput from '../components/common/text-input';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate, useLoaderData } from "react-router-dom";
import '../styles/users.scss';

export default function Users() {
  console.log(useLoaderData())
  const [users, setUsers] = useState(useLoaderData());
  
  const workspaceOwner = useMemo(() => {
    return users.find((user) => user.is_account_owner) || {}
  }, [users])

  const admins = useMemo(() => {
    return users.filter((user) => user.is_admin && !user.is_account_owner)
  }, [users])

  const regularUsers = useMemo(() => {
    return users.filter((user) => !user.is_admin && !user.is_account_owner)
  }, [users])

  return (
    <div className='UsersContainer'>
      <h3>Workspace Owner</h3>
      <table className='Table_rowList'>
        <TableHeader />
        <tbody>
          <tr>
            <td>{workspaceOwner.first_name} {workspaceOwner.last_name}</td>
            <td>{workspaceOwner.email}</td>
            <td>{workspaceOwner.user_name}</td>
          </tr>
        </tbody>
      </table>
      <h3>Admins</h3>
      <table className='Table_rowList'>
        <TableHeader />
        <tbody>
          {admins.map((admin) => {
            console.log(admin)
            return (
              <tr>
                <td>{admin.first_name} {admin.last_name}</td>
                <td>{admin.email}</td>
                <td>{admin.user_name}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <h3>Users</h3>
      <table className='Table_rowList'>
        <TableHeader />
        <tbody>
          {regularUsers.map((user) => {
            return (
              <tr>
                <td>{user.first_name} {user.last_name}</td>
                <td>{user.email}</td>
                <td>{user.user_name}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );
};

function TableHeader() {
  return (
    <thead>
      <tr>
        <th>
          Name
        </th>
        <th>
          Email
        </th>
        <th>
          Username
        </th>
      </tr>
    </thead>
  )
}